import { Platform } from 'react-native';
import { getBrand } from 'react-native-device-info';

import manifest from '../../manifest.json';

export const isWeb = Platform.OS === 'web';
export const isTizen = window.tizen ? true : false;
export const isVizio = /VIZIO/g.test(navigator.userAgent);
// X1 devices use a version of webkit called WPE
export const isX1 = /WPE/g.test(navigator.userAgent);
export const isWebkit = /AppleWebKit/g.test(navigator.userAgent) && !/Chrome/g.test(navigator.userAgent);
export const isAndroid = Platform.OS === 'android';
export const isTVOS = Platform.isTVOS;
export const isFireTV = getBrand().toLowerCase() === 'amazon';
export const isGoogleTV = getBrand().toLowerCase() !== 'amazon' && isAndroid;

export const canPurchaseOnPlatform = isFireTV;
export const canManageSubscriptionsOnPlatform = false;

export const DEBUG = manifest?.debug === undefined ? false : manifest.debug;
export const QA = manifest?.qa === undefined ? false : manifest.qa;

export const getTizenVersion = () => {
  if (!isTizen) {
    return null;
  }
  const regex = /Tizen \d.\d/g;

  if (!regex.test(navigator.userAgent)) {
    return null;
  }
  const version = navigator.userAgent.match(regex)[0].split(' ')[1];

  return parseInt(version, 10);
};

export const platformName = () => {
  if (isTizen) {
    return 'Samsung';
  }

  if (isX1) {
    return 'X1';
  }

  if (isVizio) {
    return 'Vizio';
  }

  if (isFireTV) {
    return 'FireTV';
  }

  if (isGoogleTV) {
    return 'GoogleTV';
  }

  if (isTVOS) {
    return 'TVOS';
  }
};
